require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 997
// module chunks = 0 1